import React from 'react';
import { Bell, Menu, X, MessageSquare } from 'lucide-react';
import { currentUser } from '../../data/currentUser';
export function Topbar({
  isMobileMenuOpen,
  setIsMobileMenuOpen
}) {
  return <div className="h-16 sticky top-0 z-30 bg-white/75 backdrop-blur-xl border-b border-gray-200/70 flex items-center justify-between px-4 md:px-6" data-id="element-244">
      <div className="flex items-center" data-id="element-245">
        <button className="lg:hidden mr-3 text-[#376770] hover:text-[#2d5459] transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-246">
          {isMobileMenuOpen ? <X size={20} data-id="element-247" /> : <Menu size={20} data-id="element-248" />}
        </button>
      </div>
      <div className="flex items-center space-x-4 md:space-x-5" data-id="element-249">
        <button className="p-1 relative" data-id="element-250">
          <Bell size={20} className="text-gray-700" data-id="element-251" />
          <span className="absolute -top-1 -right-1 bg-[#C6D6AB] text-gray-800 text-xs rounded-full h-4 w-4 flex items-center justify-center" data-id="element-252">
            3
          </span>
        </button>
        <button className="p-1 relative" data-id="element-253">
          <MessageSquare size={20} className="text-gray-700" data-id="element-254" />
          <span className="absolute -top-1 -right-1 bg-[#C6D6AB] text-gray-800 text-xs rounded-full h-4 w-4 flex items-center justify-center" data-id="element-255">
            5
          </span>
        </button>
        <div className="flex items-center space-x-3" data-id="element-256">
          <div className="h-9 w-9 rounded-full overflow-hidden ring-2 ring-[#EFF2F1]" data-id="element-257">
            <img src={currentUser.image} alt={currentUser.name} className="h-full w-full object-cover" data-id="element-258" />
          </div>
          <div className="hidden sm:block" data-id="element-259">
            <div className="text-sm font-medium text-gray-900" data-id="element-260">
              {currentUser.name}
            </div>
            <div className="text-xs text-gray-500" data-id="element-261">Author</div>
          </div>
        </div>
      </div>
    </div>;
}